import { MatchTeamPlayerCell as MatchTeamPlayerCellComponent } from './MatchTeamPlayerCell.component';
import { connector } from './MatchTeamPlayerCell.connector';

export const MatchTeamPlayerCell = connector(MatchTeamPlayerCellComponent);
